import React from 'react';
import { Loader, Brain } from 'lucide-react';

interface LoadingStateProps {
    message?: string;
    icon?: 'loader' | 'brain';
}

export const LoadingState: React.FC<LoadingStateProps> = ({
                                                              message = 'Loading...',
                                                              icon = 'loader'
                                                          }) => {
    const Icon = icon === 'brain' ? Brain : Loader;
    const iconClass = icon === 'loader' ? 'animate-spin' : '';

    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh]">
            <Icon className={`w-6 h-6 sm:w-8 sm:h-8 text-blue-500 mb-4 ${iconClass}`} />
            <div className="text-gray-200 text-sm sm:text-base">{message}</div>
        </div>
    );
};